import React from "react";
import {useTranslation} from "react-i18next";
import {IconSource} from "../../../shared/enums/iconSource";
import HeaderProgressBar from "../../atoms/headerProgressBar/headerProgressBar";
import PageHeading from "../../organisms/pageHeading/pageHeading";

export interface INoticesListHeaderProps {
  /**
   * Indicate that the component is loading. When set to true, a progress bar will be revealed.
   */
  isLoading: boolean;

  /**
   * The callback for create notice button click event.
   */
  createNoticeOnClick: () => void;
}

/**
 * The header for notices list view.
 */
const NoticesListHeader: React.FC<INoticesListHeaderProps> = ({
  isLoading,
  createNoticeOnClick
}) => {
  const {t} = useTranslation(["translation", "notice"]);

  return (
    <div>
      <PageHeading
        title={t("titles.notices")}
        actionTitle={t("notice:labels.add")}
        actionIcon={IconSource.add}
        onActionClicked={createNoticeOnClick}
      />
      <HeaderProgressBar progressBarLoading={isLoading} />
    </div>
  );
};

export default NoticesListHeader;
